import React from 'react';
import Main from './Main';

/**  MainContainer is the container for the raw app state,
 *  where data is fetched for the menus and processed, where the
 *  query strings are processed and changed, and all data is passed
 *  down to the app.
 */
export default class MainContainer extends React.Component {
  state = {};
  /**
   * Retrieve dates and data -- all essential for the
   * app to render
   *
   */
  async componentWillMount() {
    const dates = await this.getDates();
    const data = await this.getData();
    const initialState = this.getInitialState(data, dates);
    this.setState({ dates, data, initialState });
  }

  /** Fetches the list of directories named with date strings
   * At present no part of this app is smart. Date log is the
   * product of a manual listing process.
   * @return {string[]} text - an Array of strings that are processed for DateMenu
   */
  async getDates() {
    let response = await fetch(
      'https://wof.nssl.noaa.gov/realtime/data/dateLog.txt',
      {
        headers: { accept: 'text/xml' },
        method: 'GET'
      }
    ).catch(err => {
      console.log(err);
    });
    let text = await response.text();
    // flat text is split on new line, filered for strings of length 8, all numbers
    // ideally YYYYMMDD
    text = text
      .split('\n')
      .filter(str => /\d{8,8}/.test(str) && str.length === 8);
    return text;
  }

  /**
   * Fetches json to populate the menus and provide unit rules and limits on cycles
   * @return {Object} json - the app data
   */
  async getData() {
    let response = await fetch('./data/newse_realtime.json', {
      headers: { accept: 'text/json' },
      method: 'GET'
    }).catch(err => {
      console.log(err);
    });
    return response.json();
  }

  /** Processes query strings, if any, and sets initial state object for Main
   * @param {Object} data - the data object
   * @param {string[]} dates - the dates array
   * @return {{ selectedDate: string, selectedCycle: string, selectedField: string, selectedUnit: string,     selectedFieldUnitType: string }}
   */
  getInitialState = (data, dates) => {
    // the date is d, cycle is c, and the product field is f.
    // these abbreviated variable names are legacy. to change them would confuse scientists?
    // if there's a query string arg for date, cycle, and/or field, use that, else use a default
    // in the case of dates,
    // if formatted like we expect, they will sort early to latest. we want latest by default.
    const d = this.getUrlParameter('d')
      ? this.getUrlParameter('d')
      : dates[dates.length - 1];
    const c = this.getUrlParameter('c') ? this.getUrlParameter('c') : '1900';
    const f = this.getUrlParameter('f') ? this.getUrlParameter('f') : 'temp';
    const member = f.includes('member');
    const products_units_lookup = this.getProductUnitLookup(data);
    const unit = member ? '000' : data.units[products_units_lookup[f]].start;
    return {
      selectedDate: d.substr(0, 8), // there was once a tendency to name directories YYYYMMDD00
      // these cases should have been deleted by now, but just in case
      selectedCycle: c,
      selectedField: f,
      selectedUnit: unit || '000',
      selectedFieldUnitType: member
        ? 'minutes'
        : products_units_lookup[f] || 'minutes'
    };
  };

  /** Loop through the given object to find and map values to their unit type
   * @param {Object} dat - an object
   * @return {{ value: string }} - an object where values are mapped to unit type
   */
  getProductUnitLookup = dat => {
    const data = dat.fields;
    let products_units_lookup = {};
    Object.keys(data).forEach(category => {
      Object.keys(data[category]).forEach(subcategory => {
        Object.keys(data[category][subcategory]).forEach(product => {
          Object.keys(data[category][subcategory][product]).forEach(wtf => {
            let value = data[category][subcategory][product][wtf].productFile;
            let unit = data[category][subcategory][product][wtf].units;
            products_units_lookup[value] = unit;
          });
        });
      });
    });
    return products_units_lookup;
  };

  /** Manually grab the query string for the arg we ask for.
   * Borrowed from https://davidwalsh.name/query-string-javascript
   * @param {string} name - can be any string, but in this app, it will be a char,
   *       the name of the query string parameter we want the value of
   * @return {string} - the value of name, or null
   */
  getUrlParameter = name => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(window.location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  // make sure we have data before we render Main
  // we have a fallback on the json. we can pass it as props or fetch it through state.
  render() {
    if (this.state.dates || this.state.data) {
      return (
        <div>
          <div className="banner">
            <img
              src={`../newse_images/${this.state.data.banner}`}
              alt="WoFS Forecast Viewer"
              onError={e => {
                e.target.src =
                  'https://wof.nssl.noaa.gov/newse_images/banner.jpg';
              }}
            />
          </div>
          <Main
            dates={this.state.dates}
            data={this.props.data || this.state.data}
            initialState={this.state.initialState}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/MainContainer.js